import { CompanyFeed } from '@/components/CompanyFeed';

import { FullAnalysisLink } from '../FullAnalysisLink';

interface Props {
  canonicalURL: string;
}

export const Updates = ({ canonicalURL }: Props) => (
  <>
    <CompanyFeed lookup={canonicalURL} />
    <FullAnalysisLink canonicalURL={canonicalURL} />
  </>
);
